import { render, staticRenderFns } from "./KeySpecs.vue?vue&type=template&id=7dc4491e&scoped=true"
import script from "./KeySpecs.vue?vue&type=script&lang=js"
export * from "./KeySpecs.vue?vue&type=script&lang=js"
import style0 from "./KeySpecs.vue?vue&type=style&index=0&id=7dc4491e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc4491e",
  null
  
)

export default component.exports